import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './ContactsListLoadingConfig.Styles';

const createItemPlaceholder = theme => [
  {
    left: setLoadingConfigObject('circle', 1, null, styles.contactImagePlaceholder),
    main: [
      setLoadingConfigObject('line', 1, '82%', styles.contactNamePlaceholder),
      setLoadingConfigObject('line', 1, '82%', styles.linePlaceholderHeight),
    ],
    style: styles.contactItemPlaceholder(theme),
  },
  createSeperator(),
];

const createSeperator = () => ({
  main: setLoadingConfigObject('line', 1, '100%', styles.seperator),
});
const loadingConfig = theme => [
  {
    main: setLoadingConfigObject('line', 1, '47.2%', styles.linePlaceholderHeight),
    style: styles.searchPlaceholder(theme),
  },
  {
    main: setLoadingConfigObject('line', 1, '26.6%', styles.linePlaceholderHeight),
    style: styles.titlePlaceholder(theme),
  },
  createSeperator(),
  ...createItemPlaceholder(theme),
  ...createItemPlaceholder(theme),
  ...createItemPlaceholder(theme),
];

export { loadingConfig, shimmerPlaceholderConfig };
